import React from 'react';
import { REPORT_SECTIONS, ReportSection } from './types';

interface ReportProgressBarProps {
  sections: ReportSection[];
  onSectionClick: (sectionId: string) => void;
}

const getScoreColor = (score: number | null | undefined): string => {
  if (score == null) return 'bg-slate-200';
  if (score >= 70) return 'bg-emerald-500';
  if (score >= 40) return 'bg-amber-400';
  return 'bg-red-400';
};

const getScoreLabel = (score: number | null | undefined): string => {
  if (score == null) return 'No data';
  return `${score}%`;
};

export const ReportProgressBar: React.FC<ReportProgressBarProps> = ({ sections, onSectionClick }) => {
  return (
    <div className="flex gap-1.5 w-full">
      {REPORT_SECTIONS.map((def) => {
        const section = sections.find(s => s.id === def.id);
        const score = section?.readiness?.score ?? null;
        const hasContent = !!section?.content;
        const isGenerating = !!section?.isGenerating;

        return (
          <button
            key={def.id}
            onClick={() => onSectionClick(def.id)}
            className="flex-1 group relative"
            title={`${def.title}: ${getScoreLabel(score)}${hasContent ? ' (generated)' : ''}${isGenerating ? ' (generating...)' : ''}`}
          >
            <div className={`h-2 rounded-full transition-all ${
              isGenerating
                ? 'bg-primary/60 animate-pulse ring-2 ring-primary/30'
                : `${getScoreColor(score)} ${hasContent ? 'ring-2 ring-primary/30' : ''}`
            }`} />
            <span className="hidden group-hover:block absolute top-full mt-1 left-1/2 -translate-x-1/2 text-[10px] font-medium text-slate-600 whitespace-nowrap bg-white px-1.5 py-0.5 rounded shadow-sm border z-10">
              {def.title.length > 18 ? def.title.substring(0, 18) + '...' : def.title}
              {isGenerating ? ' (generating...)' : ''}
            </span>
          </button>
        );
      })}
    </div>
  );
};
